import React from 'react';
import styles from './index.module.scss';
import PostBlock from './post_block';

const Post = ({ publication, globalIndex }) => {
  const [publicationData, setPublicationData] = React.useState(null);
  const [contentData, setContentData] = React.useState(null);
  const postRef = React.useRef(null);

  // React.useEffect(() => {
  //   console.log('Post render:', { publication, globalIndex, contentData });
  // }, [publication, globalIndex, contentData]);

  React.useEffect(() => {
    if (publication) {
      setPublicationData(publication);
    }
  }, [publication]);

  React.useEffect(() => {
    if (postRef.current && publication?.eng_name) {
      const rect = postRef.current.getBoundingClientRect();
      if (rect) {
        const coordinates = {
          eng_name: publication.eng_name,
          template_name: publication.template?.template_name,
          parent_tab: publication.parent_tab,
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
          scrollY: window.scrollY,
          absoluteY: rect.top + window.scrollY,
        };

        if (!window.postCoordinates) {
          window.postCoordinates = {};
        }
        window.postCoordinates[publication.eng_name] = coordinates;
      }
    }
  }, [contentData, publication]);

  React.useEffect(() => {
    if (publicationData && publicationData.content) {
      try {
        const parsedContent = JSON.parse(publicationData.content);
        setContentData(parsedContent);
      } catch (error) {
        setContentData(null);
      }
    }
  }, [publicationData]);

  return (
    <div
      ref={postRef}
      className={styles.post}
      data-eng-name={publication?.eng_name}
      data-template-name={publication?.template?.template_name}
      data-parent-tab={publication?.parent_tab}>
      {contentData && Array.isArray(contentData) && (
        <div className={styles.blocksContainer}>
          {contentData.map((block, index) => (
            <PostBlock
              key={index}
              blockData={block}
              path_to_folder={'https://' + publicationData?.path + publicationData.eng_name + '/'}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Post;
